<template>
	<div class="Offer">
		<div class="Offer__image">
			<img :src="require(`@/assets/images/icons/${imgID}.svg`)">
		</div>
		<div class="Offer__title">
			<h5>{{ title }}</h5>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Offer',
	props: {
		title: {
			type: String,
			required: true
		},
		imgID: {
			type: String,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>

.Offer {
	padding: 20px;

	@media screen and (min-width: 768px) {
		width: 50%;
	}
	@media screen and (min-width: 1024px) {
		width: auto;
	}

	&:last-child {
		margin-bottom: 0;
	}

	&__image,
	&__title {
		width: 100%;
		text-align: center;
	}

	&__image {
		margin-bottom: 20px;

		img {
			background: rgba(255, 255, 255, 0.9);
			padding: 10px;
			width: 80px;
			height: 80px;
			border-radius: 10px;
			margin: 0 auto;

			@media screen and (min-width: 425px) {
				width: 150px;
				height: 150px;
			}
			@media screen and (min-width: 768px) {
				width: 180px;
				height: 180px;
			}
		}
	}

	&__title {
		h5 {
			margin: 0;
			text-transform: uppercase;
			font-size: 1.2em;
			color: white;
			font-weight: 400;

			@media screen and (min-width: 1024px) {
				font-size: 1.4em;
			}
		}
	}
}

</style>
